import { useState } from 'react';
import DanielKayser from '../../img/Daniel-Kayser_AEWmyHome_Round.png';

const AddressWidget = ({ onAddressSubmitted, campaignInfo }) => {

  const [code, setCode] = useState(campaignInfo.code + '')
  const [name, setName] = useState(campaignInfo.name + '')
  const [firstName, setFirstName] = useState(campaignInfo.firstName + '')
  const [street, setStreet] = useState(campaignInfo.street + '')
  const [streetNr, setStreetNr] = useState(campaignInfo.streetNr + '')
  const [zip, setZip] = useState(campaignInfo.zip + '')
  const [town, setTown] = useState(campaignInfo.town + '')
  const [phone, setPhone] = useState(campaignInfo.phone + '')
  const [eMail, setEMail] = useState(campaignInfo.eMail + '')
  const [marketing, setMarketing] = useState(campaignInfo.marketing)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault();

    const form = e.target;
    if (!form.checkValidity()) {
      form.classList.add('was-validated');
      return;
    }

    if (!marketing) {
      return;
    }

    setIsSubmitting(true);

    try {
      await onAddressSubmitted(name, firstName, street, streetNr, zip, town, phone, eMail, marketing, code);
    } catch (error) {
      console.error("Fehler beim Senden des Formulars:", error);
    } finally {
      setIsSubmitting(false);
    }
  };


  return (
    <div style={{ backgroundColor: 'transparent' }}>
      {/* Centered Container with Max Width */}
      <div className="container d-flex justify-content-center" style={{ maxWidth: '1400px' }}>

        {/* Bootstrap row with flex and space between */}
        <div className="row d-flex flex-column flex-lg-row align-items-start justify-content-between w-100">

          {/* Left Text Section */}
          <div className="col-12 col-lg-5 mt-3 text-white" style={{ maxWidth: '500px', flexShrink: 0 }}>
            {/*<h1>AEW myHome Messeangebot</h1>
            <p className="fs-5">
              <b>Danke,</b> für Ihr Interesse am Messeangebot. Bestellen Sie bis <b>30.6.2025</b> AEW myHome Solar oder AEW myHome Wärme und erhalten Sie CHF 1000.- Messerabatt pro Komponente.
              <br /><br />
              Berechnen Sie jetzt mit wenigen Klicks Ihr kostenloses Richtangebot.
            </p>*/}

            {/* Contact Card */}
            <div className="CardPhoneNR rounded shadow-lg">
              <div className="row g-1">
                <div className="CardPhoto col-md-2">
                  <img src={DanielKayser} className="PhoneIMG img-fluid rounded-start" alt="AEW Logo" />
                </div>
                <div className="col-md-10 row align-items-center">
                  <div className="CardBody">
                    <h5 className="card-title">+41 62 834 21 11</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Form Section */}
          <div
            className="col-12 col-lg-5 p-4 shadow-lg rounded bg-white w-100 w-lg-auto"
            style={{ maxWidth: '500px' }}
          >
            <h3 style={{ color: '#161d61' }}>Meine Angaben für die unverbindliche Richtofferte</h3>
            <br />
            <form onSubmit={handleSubmit}
              className="needs-validation"
              noValidate>
              <div className="row g-1">
              <div class="form-floating mb-2">
  <select class="form-select" id="floatingSelect" aria-label="Floating label select example">
    <option value="1">Herr</option>
    <option value="2">Frau</option>
  </select>
  <label for="floatingSelect">Anrede</label>
</div>
              {/*<div className="form-check">
              <label htmlFor="txtFirstName"><span className="text-danger">* </span>Anrede</label>
  <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" />
  <label class="form-check-label" for="flexRadioDefault1">
    Man
  </label>
</div>
<div class="form-check">
  <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2"/>
  <label class="form-check-label" for="flexRadioDefault2">
    Frau
  </label>
</div>*/}
                <div className="col-md-6 form-floating mb-2">
                  <input required type="text" className="form-control" id="txtFirstName" placeholder="" onChange={e => setFirstName(e.target.value)} value={firstName} />
                  <label htmlFor="txtFirstName"><span className="text-danger">* </span>Vorname</label>
                </div>
                <div className="col-md-6 form-floating mb-2">
                  <input required type="text" className="form-control" id="txtLastname" placeholder="" onChange={e => setName(e.target.value)} value={name} />
                  <label htmlFor="txtLastname"><span className="text-danger">* </span>Nachname</label>
                </div>
                <div className="col-md-10 form-floating mb-2">
                  <input required type="text" className="form-control" id="txtStreet" placeholder="" onChange={e => setStreet(e.target.value)} value={street} />
                  <label htmlFor="txtStreet"><span className="text-danger">* </span>Strasse</label>
                </div>
                <div className="col-md-2 form-floating mb-2">
                  <input required type="text" className="form-control" id="txtStreetNumber" placeholder="" onChange={e => setStreetNr(e.target.value)} value={streetNr} />
                  <label htmlFor="txtStreetNumber"><span className="text-danger">* </span>Nr.</label>
                </div>
                <div className="col-md-3 form-floating mb-2">
                  <input required type="text" className="form-control" id="txtZip" placeholder="" onChange={e => setZip(e.target.value)} value={zip} />
                  <label htmlFor="txtZip"><span className="text-danger">* </span>PLZ</label>
                </div>
                <div className="col-md-9 form-floating mb-2">
                  <input required type="text" className="form-control" id="txtTown" placeholder="" onChange={e => setTown(e.target.value)} value={town} />
                  <label htmlFor="txtTown"><span className="text-danger">* </span>Ort</label>
                </div>
                <div className="form-floating mb-2">
                  <input required type="text" className="form-control" id="txtEmail" placeholder="" onChange={e => setEMail(e.target.value)} value={eMail} />
                  <label htmlFor="txtEmail"><span className="text-danger">* </span>E-Mail</label>
                </div>
                <div className="form-floating mb-2">
                  <input type="text" className="form-control" id="txtPhone" placeholder="" onChange={e => setPhone(e.target.value)} value={phone} />
                  <label htmlFor="txtPhone">Telefon</label>
                </div>
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" id="chkMarketing" onChange={e => setMarketing(e.target.checked)} checked={marketing} />
                  <label className="form-check-label" htmlFor="chkMarketing">
                    Durch die Nutzung stimmen Sie unseren <a target='_blank' href="https://www.aew.ch/agb" title='AEW Energie AG - AGB'>AGB</a> und der <a target='_blank' href="https://www.aew.ch/datenschutz" title='AEW Energie AG - Datenschutzerklärung'>Datenschutzerklärung</a> zu.
                  </label>
                </div>
              </div>
              <br />
              {/*<input type="button" className="btn btn-primary" disabled={!marketing} onClick={() => onAddressSubmitted(name, firstName, street, zip, town, phone, eMail, marketing, code)} value="Jetzt vom Messerabatt profitieren" />*/}
              <button
                type="submit"
                className="btn btn-primary"
                disabled={
                  isSubmitting ||                     // While submitting
                  !marketing ||                      // Checkbox must be checked
                  !firstName.trim() ||
                  !name.trim() ||
                  !street.trim() ||
                  !streetNr.trim() ||
                  !zip.trim() ||
                  !town.trim() ||
                  !eMail.trim()
                }
              >
                {isSubmitting ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Wird gesendet...
                  </>
                ) : (
                  "Richtofferte erhalten"
                )}
              </button>


            </form>
          </div>

        </div>
      </div>
    </div>


  );


}

export default AddressWidget;
